import en from './en';
import zhHK from './zh-HK';
import zhCN from './zh-CN';

export default {
  en,
  'zh-HK': zhHK,
  'zh-CN': zhCN,
};



// WEBPACK FOOTER //
// ./src/locales/index.js